import { render, staticRenderFns } from "./AppReceiptA4.vue?vue&type=template&id=185636be&scoped=true&"
import script from "./AppReceiptA4.vue?vue&type=script&lang=js&"
export * from "./AppReceiptA4.vue?vue&type=script&lang=js&"
import style0 from "./AppReceiptA4.vue?vue&type=style&index=0&id=185636be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185636be",
  null
  
)

export default component.exports